import { render, staticRenderFns } from "./NavbarLayout.vue?vue&type=template&id=5f536c43&scoped=true"
import script from "./NavbarLayout.vue?vue&type=script&lang=js"
export * from "./NavbarLayout.vue?vue&type=script&lang=js"
import style0 from "./NavbarLayout.vue?vue&type=style&index=0&id=5f536c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f536c43",
  null
  
)

export default component.exports